import Layout from "@/components/PageLayout/index";
import PrivateRoute from "./privateRouter";
import { routeConfig } from "./route";
import { CrossBorderCampaignRouterMap, useCrossBorderCampaignRouterMap } from "@CrossBorder/router";
import { lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";
export const BZALazyLoad = (path: string) => {
  const Comp = lazy(() => import("@BZA/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};
export const CrossBorderLazyLoad = (path: string) => {
  const Comp = lazy(() => import("@CrossBorder/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

export const CrossBorderCIDRouterPages: routeConfig[] = [
  {
    path: "/Non_dashboard",
    element: BZALazyLoad("Account/Dashboard"),
    name: "首页",
    key: "homeKey",
    icon: "Home",
  },
  {
    path: "/Non_report",
    element: CrossBorderLazyLoad("Reoprt/index"),
    name: "报表统计",
    key: "tableKey",
    icon: "Table",
    children: [
      {
        path: "effectReport",
        name: "效果报告",
        key: "effectReportKey",
        element: CrossBorderLazyLoad("Reoprt/effectReport"),
      }
    ]
  },
  {
    path: "/Non_waitingOrder",
    element: CrossBorderLazyLoad("Agency/WaitOrder/WaitOrder"),
    name: "下单管理",
    key: "waitingOrderKey",
    icon: "inquiryorder-svg",
  },
  {
    path: "/Non_completeorder",
    element: CrossBorderLazyLoad("Agency/Order/Order"),
    name: "订单管理",
    key: "completeorderKey",
    icon: "order-svg",
  },
  {
    path: "/Non_waitingOrder/inquirydetails/:cid/:inquiryId",
    element: CrossBorderLazyLoad("Quotation/inquirydetailed"),
    name: "查看报价",
    key: "waitingOrderInquirydetailsKey",
    isHidden: true,
    fromPath: "/Non_waitingOrder",
    pathReg: /\/Non_waitingOrder\/inquirydetails\/\d+\/\d+/,
  },
  {
    path: "/Non_completeorder/details/:cid/:inquiryId",
    element: CrossBorderLazyLoad("Agency/Order/detaile"),
    name: "订单详情",
    key: "completeorderdetailsKey",
    isHidden: true,
    fromPath: "/Non_completeorder",
    pathReg: /\/Non_completeorder\/details\/\d+\/\d+/,
  },
  {
    path: "/Non_billingManagement",
    element: CrossBorderLazyLoad("Agency/Billing/index.tsx"),
    name: "结算管理",
    key: "billingManagementKey",
    icon: "billing-svg",
  },
  {
    path: "/Non_AccountsManagement",
    element: CrossBorderLazyLoad("Setting/index"),
    name: "账号设置",
    key: "contactListKey",
    icon: "ContactList",
  },
  {
    path: "/Non_createAccount",
    element: CrossBorderLazyLoad("Account/createAccount"),
    name: "创建账号",
    key: "accountKey",
    icon: "Repair",
    isHidden: true
  }
];

export const CrossBorderAIDRouterPages: routeConfig[] = [
  {
    path: "/Non_dashboard",
    element: BZALazyLoad("Account/Dashboard"),
    name: "首页",
    key: "homeKey",
    icon: "Home",
  },
  ...CrossBorderCampaignRouterMap,
  {
    path: "/Non_report",
    element: CrossBorderLazyLoad("Reoprt/index"),
    name: "报表统计",
    key: "tableKey",
    icon: "Table",
    children: [
      {
        path: "effectReport",
        name: "效果报告",
        key: "effectReportKey",
        element: CrossBorderLazyLoad("Reoprt/effectReport"),
      }
    ]
  },
  {
    path: "/Non_toolset",
    name: "工具中心",
    key: "repairKey",
    icon: "Repair",
    element: CrossBorderLazyLoad("ToolCenter/index"),
    children: [
      {
        path: "campaignCenter",
        element: CrossBorderLazyLoad("ToolCenter/AdCreativeCenter"),
        name: "物料中心",
        key: "campaignCenter",
        icon: "campaignCenter",
      },
      {
        path: "campaignCenter/createCampaign",
        element: CrossBorderLazyLoad("ToolCenter/createAdCreative"),
        name: "新建物料",
        editName: "编辑物料",
        key: "createCampaign",
        icon: "createCampaign",
        isHidden: true,
        fromPath: "/Non_toolset/campaignCenter",
      },
    ],
  },
  // ...CrossBorderUniversalRouters,
];

export const CrossBorderCIDRouter: routeConfig[] = [
  {
    path: "/",
    element: (
      <PrivateRoute>
        <Layout />
      </PrivateRoute>
    ),
    name: "",
    children: [
      ...CrossBorderCIDRouterPages
    ],
  }
];

export const CrossBorderAIDRouter: routeConfig[] = [
  {
    path: "/",
    element: (
      <PrivateRoute>
        <Layout />
      </PrivateRoute>
    ),
    name: "",
    children: [
      ...CrossBorderAIDRouterPages
    ],
  }
];

export const useCrossBorderCIDRouterPages = () => {
  const { t } = useTranslation();
  return [
    {
      path: "/Non_dashboard",
      element: BZALazyLoad("Account/Dashboard"),
      name: t("routes.dashboard"),
      key: "homeKey",
      icon: "Home",
    },
    {
      path: "/Non_report",
      element: CrossBorderLazyLoad("Reoprt/index"),
      name: t("routes.reportStatistics"),
      key: "tableKey",
      icon: "Table",
      children: [
        {
          path: "effectReport",
          name: t("routes.effectReport"),
          key: "effectReportKey",
          element: CrossBorderLazyLoad("Reoprt/effectReport"),
        }
      ]
    },
    {
      path: "/Non_waitingOrder",
      element: CrossBorderLazyLoad("Agency/WaitOrder/WaitOrder"),
      name: t("routes.PurchaseOrderManagement"),
      key: "waitingOrderKey",
      icon: "inquiryorder-svg",
    },
    {
      path: "/Non_completeorder",
      element: CrossBorderLazyLoad("Agency/Order/Order"),
      name: t("routes.orderManagement"),
      key: "completeorderKey",
      icon: "order-svg",
    },
    {
      path: "/Non_waitingOrder/inquirydetails/:cid/:inquiryId",
      element: CrossBorderLazyLoad("Quotation/inquirydetailed"),
      name: t("routes.viewQuotation"),
      key: "waitingOrderInquirydetailsKey",
      isHidden: true,
      fromPath: "/Non_waitingOrder",
      pathReg: /\/Non_waitingOrder\/inquirydetails\/\d+\/\d+/,
    },
    {
      path: "/Non_completeorder/details/:cid/:inquiryId",
      element: CrossBorderLazyLoad("Agency/Order/detaile"),
      name: t("routes.orderDetails"),
      key: "completeorderdetailsKey",
      isHidden: true,
      fromPath: "/Non_completeorder",
      pathReg: /\/Non_completeorder\/details\/\d+\/\d+/,
    },
    {
      path: "/Non_billingManagement",
      element: CrossBorderLazyLoad("Agency/Billing/index.tsx"),
      name: t("routes.billingManagement"),
      key: "billingManagementKey",
      icon: "billing-svg",
    },
    {
      path: "/Non_AccountsManagement",
      element: CrossBorderLazyLoad("Setting/index"),
      name: t("routes.accountSettings"),
      key: "contactListKey",
      icon: "ContactList",
    },
    {
      path: "/Non_createAccount",
      element: CrossBorderLazyLoad("Account/createAccount"),
      name: t("routes.createAccount"),
      key: "accountKey",
      icon: "Repair",
      isHidden: true
    }
  ];
};

export const useCrossBorderAIDRouterPages = () => {
  const { t } = useTranslation();
  const CrossBorderCampaignRouterMap = useCrossBorderCampaignRouterMap();
  return [
    {
      path: "/Non_dashboard",
      element: BZALazyLoad("Account/Dashboard"),
      name: t("routes.dashboard"),
      key: "homeKey",
      icon: "Home",
    },
    ...CrossBorderCampaignRouterMap,
    {
      path: "/Non_report",
      element: CrossBorderLazyLoad("Reoprt/index"),
      name: t("routes.reportStatistics"),
      key: "tableKey",
      icon: "Table",
      children: [
        {
          path: "effectReport",
          name: t("routes.effectReport"),
          key: "effectReportKey",
          element: CrossBorderLazyLoad("Reoprt/effectReport"),
        }
      ]
    },
    {
      path: "/Non_toolset",
      name: t("routes.toolCenter"),
      key: "repairKey",
      icon: "Repair",
      element: CrossBorderLazyLoad("ToolCenter/index"),
      children: [
        {
          path: "campaignCenter",
          element: CrossBorderLazyLoad("ToolCenter/AdCreativeCenter"),
          name: t("routes.materialCenter"),
          key: "campaignCenter",
          icon: "campaignCenter",
        },
        {
          path: "campaignCenter/createCampaign",
          element: CrossBorderLazyLoad("ToolCenter/createAdCreative"),
          name: t("routes.createMaterial"),
          editName: t("routes.editMaterial"),
          key: "createCampaign",
          icon: "createCampaign",
          isHidden: true,
          fromPath: "/Non_toolset/campaignCenter",
        },
      ],
    },
    // ...CrossBorderUniversalRouters,
  ];
};

export const useCrossBorderCIDRouter = () => {
  const crossBorderPages = useCrossBorderCIDRouterPages();
  return [
    {
      path: "/",
      element: (
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      ),
      name: "",
      children: [...crossBorderPages],
    }
  ];
};

export const useCrossBorderAIDRouter = () => {
  const crossBorderPages = useCrossBorderAIDRouterPages();
  return [
    {
      path: "/",
      element: (
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      ),
      name: "",
      children: crossBorderPages,
    }
  ];
};
export const useCrossBorderAIDRouterConfig = () => {
  const crossBorderAIDRouterPages = useCrossBorderAIDRouterPages();
  return [
    {
      path: "/",
      element: (
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      ),
      name: "",
      children: [
        ...crossBorderAIDRouterPages
      ],
    }
  ];
};

export const useCrossBorderCIDRouterConfig = () => {
  const crossBorderCIDRouterPages = useCrossBorderCIDRouterPages();
  return [
    {
      path: "/",
      element: (
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      ),
      name: "",
      children: [
        ...crossBorderCIDRouterPages
      ],
    }
  ];
};
